const messages = {
  placeholder: {
    id: 'admin/promotions.form.scope.skus.select.placeholder',
  },
  label: {
    id: 'admin/promotions.form.scope.skus.select.label',
  },
}

export default messages
